/**
 * contextKey: Filter attribute name in PickFilterContext
 * modelKey: Attribute name in route model whose values should be filtered
 */
import {PICK_VIEWS} from "../constants/Constants";
import {AR_V2} from "../../util/Constants";

export const PickFilter = {
    CLUSTER: {
        contextKey: "cluster",
        modelKey: "routeCode"
    },
    DRIVER_TYPE: {
        contextKey: "driverType",
        modelKey: "routeType"
    },
    DEPARTURE: {
        contextKey: "departure",
        modelKey: "routeSLA"
    },
    PICK_BY_TIME: {
        contextKey: "pickByTime",
        modelKey: "routeSLA"
    },
    ROUTE_STATUS: {
        contextKey: "routeStatus",
        modelKey: "status"
    },
    HIGH_SPR: {
        contextKey: "routeSPR",
        modelKey: "routeSPR"
    },
    PICKLIST_STATUS: {
        contextKey: "picklistStatus",
        modelKey: "status"
    },
    AT_RISK: {
        contextKey: "atRisk",
        modelKey: null
    },
    MULTI_STATION_PICKLIST: {
        contextKey: "multiStationPicklists",
        modelKey: null
    },
    AISLE_GROUP_STATUS: {
        contextKey: "aisleGroupStatus",
        modelKey: "status"
    },
    PICKLIST_STATUS_IN_GRID: {
        contextKey: "picklistStatusInGrid",
        modelKey: "status"
    },
    WAVE_PLUS_X: {
        contextKey: "wavePluxXEnabled",
        modelKey: null
    }
}

export const PickStationFilter = {
    PICK_STATION: {
        contextKey: "pickWorkstations",
        modelKey: "stationID"
    },
    STATION_STATUS: {
        contextKey: "workstationStatus",
        modelKey: "STATION_STATUS"
    },
}

export const PickStationFilterKeyList = [
    "pickWorkstations",
    "workstationStatus",
];

/**
 * Show filter tags in corresponding pick view only
 * @param key
 * @param viewState
 * @param configViewModel
 * @returns {boolean|boolean}
 */
export const showKeyForViewState = (key, viewState, configViewModel) => {
    switch (configViewModel.capability) {
        case AR_V2: {
            return (
                (viewState === PICK_VIEWS.WORKSTATION_VIEW && PickStationFilterKeyList.includes(key))
                || (viewState === PICK_VIEWS.ROUTE_VIEW && !PickStationFilterKeyList.includes(key))
            );
        }
        default:
            return true;
    }
}


// WEBPACK FOOTER //
// ./src/components/pickStatus/model/PickFilter.js